<template>
  <div>
    <v-btn
      class="mx-auto"
      fab
      dark
      color="black"
      icon
      top
      large
      router
      to="/"
      replace
    >
      <v-icon dark>
        mdi-arrow-left
      </v-icon>
    </v-btn>
    <v-btn
      href="mailto:vik17ag@gmail.com"
      class="mt-9"
      fab
      dark
      color="black"
      absolute
      icon
      right
      top
      aria-label="support"
      target="_blank"
    >
      <v-icon dark large>
        mdi-help
      </v-icon>
    </v-btn>
    <v-container>
      <v-row justify="center">
        <v-avatar color="primary" size="100">
          <v-img
            alt="user"
            v-if="currentUser.photoURL"
            :src="currentUser.photoURL"
          />
          <span v-else class="white--text text-h5">{{ $t("guest") }}</span>
        </v-avatar>
      </v-row>

      <v-card flat class="mt-3 mx-auto" width="400px">
        <v-card-title class="justify-center text-h4">
          {{ currentUser.displayName }}
        </v-card-title>
      </v-card>
      <v-row justify="center"
        ><v-col cols="auto"
          ><h4>{{ $t("version") }}</h4></v-col
        ></v-row
      >
      <v-row justify="center">
        <v-card class="mx-auto pa-5" width="400px" max-height="400px">
          <div class="text-subtitle-1 font-weight-regular mx-2">
            <p v-if="currentUser.email">
              <v-icon>mdi-email</v-icon>&nbsp;{{ currentUser.email }}
            </p>
            <p v-if="currentUser.phoneNumber">
              <v-icon>mdi-phone</v-icon>&nbsp;{{ currentUser.phoneNumber }}
            </p>
            <p>
              <v-icon>mdi-web</v-icon>&nbsp;{{ $t("language") }} :
              {{
                dictionary[this.currentLang]
                  ? dictionary[this.currentLang].name
                  : ""
              }}
              <v-icon @click="addLanguage">mdi-pencil-outline</v-icon>
            </p>
            <p >
              <v-icon>mdi-account-group</v-icon>&nbsp;Public Page
              <v-icon @click="showPublicDialog=!showPublicDialog">mdi-pencil-outline</v-icon>
            </p>
            <p>
              <v-icon>mdi-translate</v-icon>&nbsp;
              {{ $t("translation_languages") }} :
              <v-chip
                class="mr-1 mb-1"
                v-for="language in languages"
                :key="language"
                >{{
                  dictionary[language] ? dictionary[language].name : ""
                }}</v-chip
              >
              <v-icon @click="openDialog">mdi-pencil-outline</v-icon>
              <v-checkbox :label="$t('show_original')" v-model="showOriginalText" @change="setOriginalText(showOriginalText)"></v-checkbox>
            </p>
            <v-dialog
              width="400"
              :value="langDialog"
              @click:outside="langDialog = langAlert = false"
            >
              <v-card>
                <v-card-title>{{ $t("default_language") }}</v-card-title>
                <v-autocomplete
                  autofocus
                  :items="arrayLanguages"
                  class="mx-5"
                  v-model="selectedLanguage"
                  @change="setLanguage(selectedLanguage)"
                ></v-autocomplete>
              </v-card>
            </v-dialog>
          </div>
        </v-card>
      </v-row>
    </v-container>
    <br />
     <v-card flat class="mt-n4 mx-auto" width="400px">

      <v-expansion-panels class="mb-16">
        <v-expansion-panel>
          <v-expansion-panel-header >
            <p class="text-center text-h5 ma-0">{{$t('premium')}} <v-icon></v-icon> </p>

          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <p>{{$t('premium_text')}}</p>
            <v-layout justify-center
        ><v-btn
          :disabled="premium"
          color="grey darken-3 white--text"
          tile
          @click="getPremium()"
          class="my-3"
        >
          <v-icon color="#FFD700">mdi-crown</v-icon>{{$t('get_premium')}} <v-icon v-if="premium">mdi-check</v-icon></v-btn
        ></v-layout
      >
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels >
    </v-card>
    <make-public-page :user="currentUser" :publicPage="publicPage" v-if="showPublicDialog" @close="showPublicDialog=false"></make-public-page>
  </div>
</template>
<script>
import { mapGetters,mapActions ,mapMutations } from "vuex";
import arrays from '../constants/array.js'
import makePublicPage from '../components/makePublicPage.vue'
export default {
  components:{makePublicPage},
  data() {
    return {
      showPublicDialog:false,
      currentUser: null,
      selectedLanguage: null,
      langDialog: false,
      languageList: [],
      arrayLanguages:arrays.languages,
      showOriginalText:true
    };
  },
  async created() {
    this.showOriginalText=this.showOriginal
    this.currentUser = this.$store.getters.getUser;
  },
  computed: {
    ...mapGetters({
      languages: "getPrimaryLanguages",
      dictionary: "getDictionary",
      currentLang: "getCurrentLang",
      premium:'getPremium',
      showOriginal:'getOriginalText',
      publicPage:'getPublicPage'
    }),
  },
  methods: {
    ...mapActions([
      'getPremium'
    ]),
    ...mapMutations(['setOriginalText']),
    openDialog() {
      this.$store.commit("togglePrimaryDialog", true);
    },
    addLanguage() {
      this.langDialog = true;
      this.languageList = this.$store.getters.getAllLanguages;
    },
    setLanguage(e) {
      this.$store.commit("setCurrentLang", e);
      this.langDialog = false;
    },
  },
};
</script>
<style scoped>
</style>
